import React, { createRef } from "react";
import LightBox from "./LightBox";

const moodRegEx = /v-mood-(positive|negative)/;

function findGallery(el) {
  while (
    (el = el.parentElement) &&
    !el.classList.contains("anecdote-gallery-dn2bak")
  );
  return el;
}

function findGraphic(el) {
  while (
    (el = el.parentElement) &&
    !el.classList.contains("anecdote-graphic-dn32ja")
  );
  return el;
}

function findRoot(el) {
  const graphic = findGraphic(el);
  const gallery = findGallery(el);

  if (gallery && gallery.className.match(moodRegEx)) {
    return gallery;
  }

  if (graphic && graphic.className.match(moodRegEx)) {
    return graphic;
  }

  return gallery || graphic;
}

function extractStyle(el) {
  const { top, left, width, height } = el.getBoundingClientRect();

  return {
    top: top,
    left: left,
    width,
    height,
    position: "absolute",
  };
}

const initState = {
  src: "",
  mood: "",
  caption: "",
  captionFontStyles: {},
  target: undefined,
};

export default class LightBoxWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = initState;
    this.image = createRef();
  }

  componentDidCatch(error, info) {
    if (this.image && this.image.current && this.image.current.style) {
      this.image.current.style.visibility = "visible";
    }
    console.error(error);
    console.info(info);
    this.setState(initState);
    this.image = createRef();
  }

  componentDidMount() {
    const images = document.querySelectorAll(
      ".anecdote-graphic-dn32ja.enable-zoom-kf4n8k .anecdote-intrinsic-embed-n42ha1, .anecdote-wysicontent-ndj4ab.auto-zoom-kf4n8k .anecdote-graphic-dn32ja:not(.disable-zoom-kf4n8k):not(.v-embed-code) .anecdote-intrinsic-embed-n42ha1:not(a)"
    );

    images.forEach((el) => {
      el.addEventListener("click", this.handleImageClick);
    });

    document.addEventListener("turbolinks:before-cache", this.handleTurbolinks);
  }

  handleTurbolinks = () => {
    if (this.image && this.image.current && this.image.current.style) {
      this.image.current.style.visibility = "visible";
    }
  };

  componentWillUnmount() {
    document.removeEventListener(
      "turbolinks:before-cache",
      this.handleTurbolinks
    );
  }

  handleImageClick = (ev) => {
    if ("ga" in global) {
      global.ga("send", "event", "Image", "Zoom");
    }
    const target = ev.target;
    this.image.current = target;
    const imageDimensions = extractStyle(target);
    const src = target.src;
    const root = findRoot(target);
    const matchMood = root.className.match(moodRegEx);
    const mood = matchMood && matchMood[1];
    const captionElement = root.querySelector(".anecdote-caption-ajkd3b p");
    const caption = captionElement && captionElement.innerHTML;

    this.setState({
      src,
      mood,
      caption,
      imageDimensions,
    });

    if (captionElement) {
      const { fontFamily, fontSize, fontWeight, lineHeight, color } =
        window.getComputedStyle(captionElement);
      this.setState({
        captionFontStyles: {
          fontFamily,
          fontSize,
          fontWeight,
          lineHeight,
          color,
        },
      });
    }

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("scroll", this.remove);
    window.addEventListener("resize", this.remove);
  };

  handleKeyDown = ({ key }) => {
    if (key === "Escape") this.remove();
  };

  remove = ({ target } = {}) => {
    if (target?.tagName === "A") return;
    this.setState({
      src: "",
      mood: "",
      caption: "",
      captionDimensions: undefined,
      imageDimensions: undefined,
    });

    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("scroll", this.remove);
    window.removeEventListener("resize", this.remove);
  };

  render() {
    const { src, mood, caption, imageDimensions, captionFontStyles } =
      this.state;

    return (
      <div onClick={this.remove}>
        <LightBox
          src={src}
          mood={mood}
          caption={caption}
          sourceImageRef={this.image}
          captionStyle={captionFontStyles}
          imageDimensions={imageDimensions}
        />
      </div>
    );
  }
}
